export const CHART_SYMBOL_WIDTH = 10;
export const CHART_SYMBOL_HEIGHT = 10;
export const POLLBAR_CHART_SYMBOL_WIDTH = 5;

export const defaultChartSeriesStyleDescription = {
  color: "#000000",
  showMarks: true,
};

export const defaultChartAxisStyleDescription = {
  showTitle: true,
  showLabels: true,
  showTickLine: true,
};
